import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScaffalidataService {

  constructor() { }

   getData() {
        return [
  {
    "id": "S_P37_W65_H167",
    "Profondita": 37,
    "Larghezza": 65,
    "LarghezzaReale": 59,
    "Altezza": 167,
    "CODICERIPIANO": "CKOPA3765C1",
    "CODICESPALLA": "CKOPR37167C",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P37_W77_H167",
    "Profondita": 37,
    "Larghezza": 77,
    "LarghezzaReale": 71,
    "Altezza": 167,
    "CODICERIPIANO": "CKOPA3777C1",
    "CODICESPALLA": "CKOPR37167C",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P37_W89_H167",
    "Profondita": 37,
    "Larghezza": 89,
    "LarghezzaReale": 83,
    "Altezza": 167,
    "CODICERIPIANO": "CKOPA3789C1",
    "CODICESPALLA": "CKOPR37167C",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P37_W94_H167",
    "Profondita": 37,
    "Larghezza": 94,
    "LarghezzaReale": 88.5,
    "Altezza": 167,
    "CODICERIPIANO": "CKOPA3794C1",
    "CODICESPALLA": "CKOPR37167C",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P37_W106_H167",
    "Profondita": 37,
    "Larghezza": 106,
    "LarghezzaReale": 100.5,
    "Altezza": 167,
    "CODICERIPIANO": "CKOPA37106C1",
    "CODICESPALLA": "CKOPR37167C",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P37_W118_H167",
    "Profondita": 37,
    "Larghezza": 118,
    "LarghezzaReale": 112.5,
    "Altezza": 167,
    "CODICERIPIANO": "CKOPA37118C1",
    "CODICESPALLA": "CKOPR37167C",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P37_W130_H167",
    "Profondita": 37,
    "Larghezza": 130,
    "LarghezzaReale": 124.5,
    "Altezza": 167,
    "CODICERIPIANO": "CKOPA37130C1",
    "CODICESPALLA": "CKOPR37167C",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P37_W148_H167",
    "Profondita": 37,
    "Larghezza": 148,
    "LarghezzaReale": 142,
    "Altezza": 167,
    "CODICERIPIANO": "CKOPA37148C1",
    "CODICESPALLA": "CKOPR37167C",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P37_W160_H167",
    "Profondita": 37,
    "Larghezza": 160,
    "LarghezzaReale": 154,
    "Altezza": 167,
    "CODICERIPIANO": "CKOPA37160C1",
    "CODICESPALLA": "CKOPR37167C",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P37_W65_H200",
    "Profondita": 37,
    "Larghezza": 65,
    "LarghezzaReale": 59,
    "Altezza": 200,
    "CODICERIPIANO": "CKOPA3765C1",
    "CODICESPALLA": "CKOPR37200C",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P37_W77_H200",
    "Profondita": 37,
    "Larghezza": 77,
    "LarghezzaReale": 71,
    "Altezza": 200,
    "CODICERIPIANO": "CKOPA3777C1",
    "CODICESPALLA": "CKOPR37200C",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P37_W89_H200",
    "Profondita": 37,
    "Larghezza": 89,
    "LarghezzaReale": 83,
    "Altezza": 200,
    "CODICERIPIANO": "CKOPA3789C1",
    "CODICESPALLA": "CKOPR37200C",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P37_W94_H200",
    "Profondita": 37,
    "Larghezza": 94,
    "LarghezzaReale": 88.5,
    "Altezza": 200,
    "CODICERIPIANO": "CKOPA3794C1",
    "CODICESPALLA": "CKOPR37200C",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P37_W106_H200",
    "Profondita": 37,
    "Larghezza": 106,
    "LarghezzaReale": 100.5,
    "Altezza": 200,
    "CODICERIPIANO": "CKOPA37106C1",
    "CODICESPALLA": "CKOPR37200C",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P37_W118_H200",
    "Profondita": 37,
    "Larghezza": 118,
    "LarghezzaReale": 112.5,
    "Altezza": 200,
    "CODICERIPIANO": "CKOPA37118C1",
    "CODICESPALLA": "CKOPR37200C",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P37_W130_H200",
    "Profondita": 37,
    "Larghezza": 130,
    "LarghezzaReale": 124.5,
    "Altezza": 200,
    "CODICERIPIANO": "CKOPA37130C1",
    "CODICESPALLA": "CKOPR37200C",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P37_W148_H200",
    "Profondita": 37,
    "Larghezza": 148,
    "LarghezzaReale": 142,
    "Altezza": 200,
    "CODICERIPIANO": "CKOPA37148C1",
    "CODICESPALLA": "CKOPR37200C",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P37_W160_H200",
    "Profondita": 37,
    "Larghezza": 160,
    "LarghezzaReale": 154,
    "Altezza": 200,
    "CODICERIPIANO": "CKOPA37160C1",
    "CODICESPALLA": "CKOPR37200C",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P47_W65_H167",
    "Profondita": 47,
    "Larghezza": 65,
    "LarghezzaReale": 59,
    "Altezza": 167,
    "CODICERIPIANO": "CKOPA4765C1",
    "CODICESPALLA": "CKOPR47167C",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P47_W77_H167",
    "Profondita": 47,
    "Larghezza": 77,
    "LarghezzaReale": 71,
    "Altezza": 167,
    "CODICERIPIANO": "CKOPA4777C1",
    "CODICESPALLA": "CKOPR47167C",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P47_W89_H167",
    "Profondita": 47,
    "Larghezza": 89,
    "LarghezzaReale": 83,
    "Altezza": 167,
    "CODICERIPIANO": "CKOPA4789C1",
    "CODICESPALLA": "CKOPR47167C",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P47_W94_H167",
    "Profondita": 47,
    "Larghezza": 94,
    "LarghezzaReale": 88.5,
    "Altezza": 167,
    "CODICERIPIANO": "CKOPA4794C1",
    "CODICESPALLA": "CKOPR47167C",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P47_W106_H167",
    "Profondita": 47,
    "Larghezza": 106,
    "LarghezzaReale": 100.5,
    "Altezza": 167,
    "CODICERIPIANO": "CKOPA47106C1",
    "CODICESPALLA": "CKOPR47167C",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P47_W118_H167",
    "Profondita": 47,
    "Larghezza": 118,
    "LarghezzaReale": 112.5,
    "Altezza": 167,
    "CODICERIPIANO": "CKOPA47118C1",
    "CODICESPALLA": "CKOPR47167C",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P47_W130_H167",
    "Profondita": 47,
    "Larghezza": 130,
    "LarghezzaReale": 124.5,
    "Altezza": 167,
    "CODICERIPIANO": "CKOPA47130C1",
    "CODICESPALLA": "CKOPR47167C",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P47_W148_H167",
    "Profondita": 47,
    "Larghezza": 148,
    "LarghezzaReale": 142,
    "Altezza": 167,
    "CODICERIPIANO": "CKOPA47148C1",
    "CODICESPALLA": "CKOPR47167C",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P47_W160_H167",
    "Profondita": 47,
    "Larghezza": 160,
    "LarghezzaReale": 154,
    "Altezza": 167,
    "CODICERIPIANO": "CKOPA47160C1",
    "CODICESPALLA": "CKOPR47167C",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P47_W65_H200",
    "Profondita": 47,
    "Larghezza": 65,
    "LarghezzaReale": 59,
    "Altezza": 200,
    "CODICERIPIANO": "CKOPA4765C1",
    "CODICESPALLA": "CKOPR47200C",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P47_W77_H200",
    "Profondita": 47,
    "Larghezza": 77,
    "LarghezzaReale": 71,
    "Altezza": 200,
    "CODICERIPIANO": "CKOPA4777C1",
    "CODICESPALLA": "CKOPR47200C",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P47_W89_H200",
    "Profondita": 47,
    "Larghezza": 89,
    "LarghezzaReale": 83,
    "Altezza": 200,
    "CODICERIPIANO": "CKOPA4789C1",
    "CODICESPALLA": "CKOPR47200C",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P47_W94_H200",
    "Profondita": 47,
    "Larghezza": 94,
    "LarghezzaReale": 88.5,
    "Altezza": 200,
    "CODICERIPIANO": "CKOPA4794C1",
    "CODICESPALLA": "CKOPR47200C",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P47_W106_H200",
    "Profondita": 47,
    "Larghezza": 106,
    "LarghezzaReale": 100.5,
    "Altezza": 200,
    "CODICERIPIANO": "CKOPA47106C1",
    "CODICESPALLA": "CKOPR47200C",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P47_W118_H200",
    "Profondita": 47,
    "Larghezza": 118,
    "LarghezzaReale": 112.5,
    "Altezza": 200,
    "CODICERIPIANO": "CKOPA47118C1",
    "CODICESPALLA": "CKOPR47200C",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P47_W130_H200",
    "Profondita": 47,
    "Larghezza": 130,
    "LarghezzaReale": 124.5,
    "Altezza": 200,
    "CODICERIPIANO": "CKOPA47130C1",
    "CODICESPALLA": "CKOPR47200C",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P47_W148_H200",
    "Profondita": 47,
    "Larghezza": 148,
    "LarghezzaReale": 142,
    "Altezza": 200,
    "CODICERIPIANO": "CKOPA47148C1",
    "CODICESPALLA": "CKOPR47200C",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P47_W160_H200",
    "Profondita": 47,
    "Larghezza": 160,
    "LarghezzaReale": 154,
    "Altezza": 200,
    "CODICERIPIANO": "CKOPA47160C1",
    "CODICESPALLA": "CKOPR47200C",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P56_W71_H167",
    "Profondita": 56,
    "Larghezza": 71,
    "LarghezzaReale": 65,
    "Altezza": 167,
    "CODICERIPIANO": "CKOPA5671GC1",
    "CODICESPALLA": "CKOPR56167GC",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P56_W82_H167",
    "Profondita": 56,
    "Larghezza": 82,
    "LarghezzaReale": 76,
    "Altezza": 167,
    "CODICERIPIANO": "CKOPA5682GC1",
    "CODICESPALLA": "CKOPR56167GC",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P56_W93_H167",
    "Profondita": 56,
    "Larghezza": 93,
    "LarghezzaReale": 87,
    "Altezza": 167,
    "CODICERIPIANO": "CKOPA5693GC1",
    "CODICESPALLA": "CKOPR56167GC",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P56_W103,5_H167",
    "Profondita": 56,
    "Larghezza": 103.5,
    "LarghezzaReale": 97.5,
    "Altezza": 167,
    "CODICERIPIANO": "CKOPA56103GC1",
    "CODICESPALLA": "CKOPR56167GC",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P56_W114,5_H167",
    "Profondita": 56,
    "Larghezza": 114.5,
    "LarghezzaReale": 108.5,
    "Altezza": 167,
    "CODICERIPIANO": "CKOPA56114GC1",
    "CODICESPALLA": "CKOPR56167GC",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P56_W125,5_H167",
    "Profondita": 56,
    "Larghezza": 125.5,
    "LarghezzaReale": 119.5,
    "Altezza": 167,
    "CODICERIPIANO": "CKOPA56125GC1",
    "CODICESPALLA": "CKOPR56167GC",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P56_W136,5_H167",
    "Profondita": 56,
    "Larghezza": 136.5,
    "LarghezzaReale": 130.5,
    "Altezza": 167,
    "CODICERIPIANO": "CKOPA56136GC1",
    "CODICESPALLA": "CKOPR56167GC",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P56_W147_H167",
    "Profondita": 56,
    "Larghezza": 147,
    "LarghezzaReale": 141,
    "Altezza": 167,
    "CODICERIPIANO": "CKOPA56147GC1",
    "CODICESPALLA": "CKOPR56167GC",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P56_W158_H167",
    "Profondita": 56,
    "Larghezza": 158,
    "LarghezzaReale": 152,
    "Altezza": 167,
    "CODICERIPIANO": "CKOPA56158GC1",
    "CODICESPALLA": "CKOPR56167GC",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P56_W71_H200",
    "Profondita": 56,
    "Larghezza": 71,
    "LarghezzaReale": 65,
    "Altezza": 200,
    "CODICERIPIANO": "CKOPA5671GC1",
    "CODICESPALLA": "CKOPR56200GC",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P56_W82_H200",
    "Profondita": 56,
    "Larghezza": 82,
    "LarghezzaReale": 76,
    "Altezza": 200,
    "CODICERIPIANO": "CKOPA5682GC1",
    "CODICESPALLA": "CKOPR56200GC",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P56_W93_H200",
    "Profondita": 56,
    "Larghezza": 93,
    "LarghezzaReale": 87,
    "Altezza": 200,
    "CODICERIPIANO": "CKOPA5693GC1",
    "CODICESPALLA": "CKOPR56200GC",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P56_W103,5_H200",
    "Profondita": 56,
    "Larghezza": 103.5,
    "LarghezzaReale": 97.5,
    "Altezza": 200,
    "CODICERIPIANO": "CKOPA56103GC1",
    "CODICESPALLA": "CKOPR56200GC",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P56_W114,5_H200",
    "Profondita": 56,
    "Larghezza": 114.5,
    "LarghezzaReale": 108.5,
    "Altezza": 200,
    "CODICERIPIANO": "CKOPA56114GC1",
    "CODICESPALLA": "CKOPR56200GC",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P56_W125,5_H200",
    "Profondita": 56,
    "Larghezza": 125.5,
    "LarghezzaReale": 119.5,
    "Altezza": 200,
    "CODICERIPIANO": "CKOPA56125GC1",
    "CODICESPALLA": "CKOPR56200GC",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P56_W136,5_H200",
    "Profondita": 56,
    "Larghezza": 136.5,
    "LarghezzaReale": 130.5,
    "Altezza": 200,
    "CODICERIPIANO": "CKOPA56136GC1",
    "CODICESPALLA": "CKOPR56200GC",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P56_W147_H200",
    "Profondita": 56,
    "Larghezza": 147,
    "LarghezzaReale": 141,
    "Altezza": 200,
    "CODICERIPIANO": "CKOPA56147GC1",
    "CODICESPALLA": "CKOPR56200GC",
    "LarghezzaSpalla": 2.7
  },
  {
    "id": "S_P56_W158_H200",
    "Profondita": 56,
    "Larghezza": 158,
    "LarghezzaReale": 152,
    "Altezza": 200,
    "CODICERIPIANO": "CKOPA56158GC1",
    "CODICESPALLA": "CKOPR56200GC",
    "LarghezzaSpalla": 2.7
  }
];
   }
}
